import React, { ForwardedRef, forwardRef } from 'react'

import { Checkbox, useTheme } from '@mui/material'
import { CheckboxProps } from '@mui/material/Checkbox'

export const CustomCheckBox = forwardRef(
  (props: CheckboxProps, ref?: ForwardedRef<HTMLButtonElement | null>) => {
    const { sx, onPointerDown, ...rest } = props

    const handlePointerDown = (event: React.PointerEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onPointerDown?.(event)
    }

    const { palette } = useTheme()
    return (
      <Checkbox
        color="default"
        ref={ref}
        sx={{
          '& .MuiSvgIcon-root': {
            color: palette.grey[700],
          },
          '&.Mui-checked .MuiSvgIcon-root': {
            color: palette.primary.main,
          },
          ...sx,
        }}
        onPointerDown={handlePointerDown}
        {...rest}
      />
    )
  },
)

CustomCheckBox.displayName = 'ForwardedCustomCheckBox'
